export const LANGUAGES_TO_DISPLAY_SAS_TOP_BAR = ["nb", "da", "sv"];
export const LANGUAGES_TO_DISPLAY_LUFTHANSA_TOP_BAR = ["de", "en-int"];
export const SLUGS_TO_DISPLAY_LUFTHANSA_TOP_BAR = [
  "airline-strike-compensation",
  "entschaedigung-bei-streik-der-fluggesellschaft",
];
